module.exports = __webpack_public_path__ + "img/logo-vodafone.91ac137f.png";